import { Box, Text } from '@chakra-ui/react';

export const InputsPreview = () => {
  return (
    <Box>
      <Text>InputsPreview - Coming soon</Text>
    </Box>
  );
};
